export function getConfigApi() {
  const config = window.config
  //config.apiGateway = 'http://27.74.251.0:5000'
  //config.gateway = 'http://27.74.251.0:5000'
  function c(prefix) {
    return config.apiGateway + '/' + prefix
  }
  return {
    gateway: config.apiGateway,
    media: config.apiMedia,
    camera: config.apiCamera,
    auth: c('auth'),
    user: c('user'),
    // user: 'http://localhost:5005/user',
    languageLocale: c('language-locale'),
    organization: c('organization'),
    //organization: 'http://localhost:5005/organization',
    qa: c('qa'),
    hook: c('admin/hooks')
    // qa:'http://192.168.1.75:5016'
  }
}



// WEBPACK FOOTER //
// ./src/config.js